import { MpxResponseBase, MpxResponseError } from '@cibo/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { CreateErrorReportRequest } from '../types'
import { AGREEMENTS_QUERY_KEY } from '.'
import { AgreementsAPI } from '../api'

export const useCreateFieldsErrorReportForUser = () => {
  const queryClient = useQueryClient()

  return useMutation<
    AxiosResponse<MpxResponseBase>,
    AxiosError<MpxResponseError>,
    CreateErrorReportRequest,
    unknown
  >({
    mutationFn: (params: CreateErrorReportRequest) => AgreementsAPI.createErrorReport(params),
    onSuccess: () => {
      queryClient.invalidateQueries([AGREEMENTS_QUERY_KEY.AGREEMENTS])
    },
  })
}
